import React from "react";
import { Link } from "react-router-dom";

export const Sidebar = () => {
  return (
    <div id="sidebar">
      <Link to="/" className="menu-item">
        Home
        <span className="menu">مرکز</span>
      </Link>
      <Link to="/PlantDiseaseDetection" className="menu-item">
        Plant Disease Detection
        <span className="menu">پودے کی بیماری</span>
      </Link>
      <Link to="/PlantHealth" className="menu-item">
        Plant Health
        <span className="menu">پودے کی صحت</span>
      </Link>
      <Link to="/FertilizerReport" className="menu-item">
        Fertilizer Report
        <span className="menu">کھاد کی رپورٹ</span>
      </Link>
      <Link to="/WaterReport" className="menu-item">
        Water Report
        <span className="menu">پانی کی رپورٹ</span>
      </Link>
      <Link to="/PlantStressReport" className="menu-item">
        Plant Stress
        <span className="menu">پودے پر دباؤ</span>
      </Link>
    </div>
  );
};
